import { render, staticRenderFns } from "./CreateUserPage.vue?vue&type=template&id=b9082476"
import script from "./CreateUserPage.vue?vue&type=script&lang=ts"
export * from "./CreateUserPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports